import {PackageStatus} from '@sollapay/enums';
import {Badge} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export interface PackageTabBadgeProps {
  status?: PackageStatus;
  isResubmitted?: boolean;
}

/** Status chip beside a package's modal tab: clarification asked, or just sent back to review. */
export const PackageTabBadge: FC<PackageTabBadgeProps> = ({status, isResubmitted = false}) => {
  const {t} = useTranslation('trustAccounts');

  if (isResubmitted) {
    return (
      <Badge variant="info" size="sm">
        {t('activation.packageStatus.inReview')}
      </Badge>
    );
  }
  if (status === PackageStatus.CLARIFICATION_REQUIRED) {
    return (
      <Badge variant="warning" size="sm">
        {t('activation.packageStatus.clarificationRequired')}
      </Badge>
    );
  }
  return null;
};
